module.exports = __webpack_public_path__ + "static/img/5.845c6e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/5.png
// module id = ndgr
// module chunks = 0